/* eslint-disable no-trailing-spaces */
import React from 'react'
import PropTypes, { object } from 'prop-types'
import {
  Link,
  Route,
  Routes
} from 'react-router-dom'
//import withStyles from '@material-ui/core/styles/withStyles'

import moduleStyle from 'assets/jss/moduleStyle.jsx'
import jquery from 'jquery'

import Actions from './actions'
//import CampaignCarousel from '../../campaign/js/campaign_carousel'

import anchorme from 'jslib/anchorme.min'

class IndexComponent extends React.Component {
  constructor() {
    super()
    this.state = {
      showCart: false
    }
  }

  componentDidMount() {
    const $ = jquery
    const vm = this

    // if passed initial data render it
    let menus = window.menus
    let business = window.business


    if (business) {
      //console.log('set data business', business,);
      //console.log('set data campaigns', campaigns,);
      const menu = menus[0] || {}

      console.log('set data menus', business, menu);

      this.setState({
        menus: menus,
        business: business,
        locations: business.locations
      })

      let colour = business.colour || menu.colour

      if (colour == undefined || colour == "" || colour == "#FFFFFF") {
        this.setState({
          detailColour: 'black'
        })
      } else if (colour.startsWith('#')) {
        this.setState({
          detailColour: colour
        })
      } else {
        this.setState({
          detailColour: `#${colour}`
        })
      }
    } else {
      //console.log('business data not present')
    }

  }

  componentWillUnmount() {
  }


  menuButton(menu) {

      //console.log("button for menu", menu, this.state)
      let hostname = window.location.host || ""

      let url = `https://zono.cc/?bid=${menu.business_id}&lid=${menu.location_id}&mid=${menu.id}`

      let location = this.state.locations.find((l) => l.id == menu.location_id)
    return (

      <div
        key={'menu_' + menu.id} className="justify-content-center"
        style={{
          flexBasis: 0,
          flexGrow: 1,
          maxWidth: '100%',
          position: 'relative',
          width: '100%',
          paddingRight: 15,
          paddingLeft: 15,
          //borderRadius: 15,
          //borderWidth: 2,
          //borderColor: 'black',
          cursor: 'pointer'
        }} >

        <div className="centered"
        >
          <div   style={{
            backgroundColor: 'white',
            color: this.state.detailColour,
            margin: 10,
            padding: 10,
            borderRadius: 15,
            //borderWidth: 2,
            //borderColor: 'black',
            //width: '80%',
            border: '2px solid black',
            fontSize: '2em',
            fontWeight: 500
          }}
          onClick={() => window.location.href = url}>
             {menu.name} {location ? `- ${ location.city}` : ''}
          </div>

        </div>

      </div>


    )
  }

  appDownloadButton(menu) {
    return (<div></div>)
    /*
    // find the link for the menu in
    // window.menulinks
    // var menulinks = {"menu_1":"https://fbh.zono.cc/YE4Q"}

      return (
 <div className="row justify-content-center" key={'offers_button_0'} >
            <div className="col-sm-12 col-md-12 centered menu-button"
              style={{
                backgroundColor: this.state.detailColour,
                color: 'white'
              }}
            >
              Ver Menu + Ofertas
            </div>
          </div>

      )
    */
  }

  /*  buttonSection(menus) {
     return (
       <div className="row justify-content-center button-section">
         <div className="col-sm-12 col-md-12 centered ">
           {menus.map((menu) => {
             return this.menuButton(menu)
           })}
         </div>
       </div>

     )
   } */

  mainBody(allMenus) {

    // filter the categories that are available
    let menus = allMenus.filter((m) => m.enabled == true)

    return (
      <div className="justify-content-center businessbody"
        style={{
          paddingTop: 50,
          flex: 1
        }}
      >
        <div className=" button-section">
          {menus.map((menu) => {
            return this.menuButton(menu)
          })}
        </div>

      </div>
    )
  }

  _statusSection(message) {
    return (<div className="centered" style={{
      marginLeft: 20,
      marginRight: 20,
      color: this.state.detailColour || 'red'
    }}>
      {message}

    </div>)
  }

  showBusiness() {

    // header image
    // business logo
    // main menu.photo as background image
    const menus = this.state.menus || [{}]
    const business = this.state.business || {}
    const campaigns = this.state.campaigns || [{}]
    const periods = this.state.periods || []
    const menu = menus[0] || {}
    const configs = business.Configs || []
    const statusMessage = configs.find((cfg) => cfg.name == 'statusMessage' && cfg.model == 'business')

    business.photo ||= "/images/default_menu_banner.png"
    menu.photo ||= "/images/food_display.png"

    let bkkstyle = {}
    let footerStyle = { padding: 20}
/*
    if (business.background) {
      bkkstyle = {
        backgroundImage: `url(${business.background})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'repeat',
        height: '100%'
      }
      footerStyle = {
        padding: 20
      }
    } else if (menu.background) {
      bkkstyle = {
        backgroundImage: `url(${menu.background})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'repeat',
        height: '100%'
      }

      footerStyle = {

        padding: 20
      }
    } */

    //console.log("render with state", this.state)

    let hostname = window.location.host || ""

    return (

      <div className="menu" style={bkkstyle} >

        <div className="row justify-content-center" style={{
          paddingTop: 50,
          paddingBottom: 30,
        }}>

          <div className="col business-logo logo-col centered" >
            <img src={business.photo} height={200} style={{
              borderRadius: 100
            }} />
          </div>

        </div>

       {/*  <Actions business={business} detailColour={this.state.detailColour || '#F1AD3E'} /> */}

        {statusMessage &&
          <div >
            {this._statusSection(statusMessage.value)}
          </div>
        }

        {this.mainBody(menus, periods)}

        <div className="centered" style={footerStyle}>
          <a href={`https://${hostname}`}>
            <img src="/images/zono-smile.png" height="50" />
          </a>
        </div>

      </div>

    )
  }

  render() {

    // show the business
    return this.showBusiness()
  }
}

IndexComponent.propTypes = {
  //classes: PropTypes.object.isRequired,
  //theme: PropTypes.object.isRequired,
}

//export default withStyles(moduleStyle, { withTheme: true })(IndexComponent)


class MenusComponent extends React.Component {
  render () {
    return (

      <Routes>
      <Route path="/" element={<IndexComponent />} />

    </Routes>

    )
  }
}

MenusComponent.propTypes = {
  //classes: PropTypes.object.isRequired,
  //theme: PropTypes.object.isRequired
}

export default  MenusComponent